module.exports = __webpack_public_path__ + "static/media/Delivery.3f06f4e6.webp";